import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import Swal from 'sweetalert2';

import moment, { Moment } from 'moment';

import { DATES_DONT_MATCH, MESSAGE_ALGO_SALIO_MAL, show_popup, TITLE_ERROR } from '@shared/utility/popup-error';

import { environment } from '@environments/environment';

import { DecisionModelWorkflow } from '@core/model/DecisionModelWorkflow';
import { DecisionModelProcessType } from '@core/model/enums/DecisionModelProcessType';
import { ProductType } from '@core/model/enums/product-type.enum';
import { RedirectionService } from '@core/service/redirection.service';
import { CustomResponseDto } from '@core/model/custom-response-dto';

import { DisbursementAccountSelectionService } from '@account/services/disbursement-account-selection.service';

import { routes } from '@model/constants/routes';

@Component({
  selector: 'app-confirm-date-of-issue',
  templateUrl: './confirm-date-of-issue.component.html',
  styleUrls: ['./confirm-date-of-issue.component.css'],
})
export class ConfirmDateOfIssueComponent implements OnInit {
  formDate: FormGroup;
  oneDate: Moment;
  secondDate: Moment;
  moment: Moment;
  minDate: Moment;
  maxDate: Moment;
  showLoader = false;
  decisionModelWorkflow = new DecisionModelWorkflow();
  private apiGatewayUrl = environment.apiGatewayUrl;
  private url = `${this.apiGatewayUrl}${routes.confirmDateOfIssue}`;

  constructor(
    private formBuilder: FormBuilder,
    private disbursementAccountService: DisbursementAccountSelectionService,
    private router: Router,
    private redirectionService: RedirectionService
  ) {
    this.minDate = moment().subtract(100, 'years');
    this.maxDate = moment();

    this.decisionModelWorkflow.decisionModelProcessType = DecisionModelProcessType.DOCUMENT_ISSUE;
    this.decisionModelWorkflow.productType = ProductType.RAPIPLAZO;
  }

  ngOnInit(): void {
    this.buildForm();
  }

  buildForm() {
    this.formDate = this.formBuilder.group({
      confirmedOneDate: [null, [Validators.required]],
      confirmedSecondDate: [null, [Validators.required]],
    });
  }

  send() {
    if (this.oneDate.valueOf() === this.secondDate.valueOf()) {
      this.decisionModelWorkflow.firsDate = moment(this.oneDate.valueOf()).format('YYYY-MM-DD');
      this.decisionModelWorkflow.secondDate = moment(this.secondDate.valueOf()).format('YYYY-MM-DD');
      this.decisionModelWorkflow.decisionModelProcessType = DecisionModelProcessType.DOCUMENT_ISSUE;
      this._callExecute();
    } else {
      show_popup(TITLE_ERROR, DATES_DONT_MATCH);
      this.showLoader = false;
    }
  }

  private _callExecute() {
    this.showLoader = true;
    this.disbursementAccountService.executeDecisionModel(this.decisionModelWorkflow, this.url).subscribe(
      (response: CustomResponseDto<any>) => {
        // tslint:disable-next-line:triple-equals
        if (response.status == '200' || response.status == '202' || response.status == null) {
          this.redirectionService.nextFlow(response.response).subscribe((value: boolean) => {
            if (!value) {
              console.error('Not a navigable object');
            }
          });
        } else if (response.response.type == 'DOCUMENT_ISSUE_OF_DATE_DOES_NOT_MATCH') {
          this.showAlert(
            'account/' + response.response.urlRedirect,
            'Fecha digitada no coincide, por favor intentalo nuevamente'
          );
        } else {
          this.router.navigate([response.response.urlRedirect]);
        }
        this.showLoader = false;
      },
      (error) => {
        this.showLoader = false;
        show_popup(TITLE_ERROR, MESSAGE_ALGO_SALIO_MAL);
      }
    );
  }

  showAlert(urlRedirection: string, message: string) {
    Swal.fire({
      title: 'Error',
      confirmButtonText: 'Confirmar',
      onClose: () => {
        this.router.navigate([urlRedirection]);
      },
      text: message,
    });
  }
}
